// extracted by mini-css-extract-plugin
export default {"textarea":"Organization_textarea__CnfTf"};